enum Shape {
	Circle = 'circle',
	Square = 'square',
}

export default Shape;
